import React, { useState, useEffect } from 'react';
import 'antd/dist/antd.css';
import Axios from "../../config/axiosConfig/axios";
import {Api} from "../../config/apiList/api";
import { Row, Col, Table, Input, Button, notification,Pagination } from 'antd';
import '../user/userList/userList.css'
import {CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { SpinnerDotted } from 'spinners-react';
import {render} from "react-dom";
import EditModal from "./editModal";
import InsertVersion from "./insertVersion";
import unsecuredCopyToClipboard from "../../config/copy_text_conf";



function UserList() {
    const [versionList, setVersionList] = useState("");
    const [step, setStep] = useState(0);
    const [search, setSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPage, setTotalPage] = useState(0);

    function changeState(newUserList){
        setVersionList(newUserList)
    }

    const GreenNotification = (text) => {
        notification.open({
            message: "موفقیت",
            description: text,
            style: {
                background: "#43a047",
                color: "white",
                fontFamily: "IRANSansMobileFaNum",
                borderRadius: "5px",
            }
        })
    }

    const RedNotification = (text) => {
        notification.open({
            message: "اخطار",
            description: text,
            style: {
                background: "#F3585c",
                color: "white",
                fontFamily: "IRANSansMobileFaNum",
                borderRadius: "5px",
            }
        })
    }

    useEffect( () => {
        Axios.get(`${Api}allVersion?page=${pageNumber}&search=${search}`
        )
            .then((data) => {
                if (data.statusCode === 200 || data.statusCode === 201) {
                    setVersionList(data.data.data);
                    setTotalPage(data.data.total_pages);
                    setStep(1);

                    // console.log("versionList", data)
                }

            })
            .catch((error) => {
                // console.log(`err is ${error}`);
            });
    }, [pageNumber]);


    const searching = () => {
        if (search.length !== 0) {
            Axios.get(`${Api}allVersion?search=${search}`)
                .then((data) => {
                    if (data.statusCode === 200 || data.statusCode === 201) {
                        setVersionList(data.data.data);
                        setTotalPage(data.data.total_pages);
                        setStep(1);
                    }

                    else {
                        RedNotification(data.message);
                    }

                })
                .catch((error) => {
                    RedNotification("مشکلی در اتصال به سرور به وجود آمده است‌ !")
                });
        } else {
            RedNotification("برای جستجو ابتدا باید نام ورژن را وارد نمایید")
        }
    }

    const columns = [
        {
            title: 'شناسه',
            dataIndex: "id",

        },
        {
            title: 'سیستم عامل',
            dataIndex: 'os',
        },

        {
            title: 'ورژن',
            dataIndex: 'name',
        },

        {
            title: 'اپ دامین',
            dataIndex: 'appDomain',

        },
        {
            title: 'منسوخ شده',
            render: (e) => {
                return e.deprecate === false? <CloseOutlined/>: <CheckOutlined/>
            },

        },

        {
            title: "تاریخ ایجاد",
            render: (e) => {
                return <p>{new Date(e.createDate).toLocaleString("fa", { year: "numeric", day: '2-digit', month: '2-digit'})}
                    {/*{new Date(e.createDate).toLocaleString("fa", {year: "numeric"})}*/}
                </p>
            },

        },

        {
            title: 'لینک دانلود',

            render: (e) => {return e.downloadsUrl ?<div>
                <p style={{fontFamily: "arial"}}>{e.downloadsUrl? "...." + e.downloadsUrl.substring(0,20): "...."}</p>
                <Button onClick={async event => {


                    await unsecuredCopyToClipboard(e.downloadsUrl);
                    notification.open({
                        message: "انجام شد",
                        description: "لینک دانلود کپی شد",
                        style: {
                            background: "#43a047",
                            color: "white",
                            fontFamily: "IRANSansMobileFaNum",
                            borderRadius: "5px",
                        }
                    })

                }} style={{  backgroundColor: "white",
                    color: "#3174ff",
                    border: "2px solid #ffffff" /* Green */}}>کپی</Button>
            </div>:<p>....</p>},

        },
        {
            title: "مود",
            // dataIndex: 'validity',
            dataIndex: "mode"

        },
        {
            title: "توضیحات",
            dataIndex: "desc"
        },


        {
            title: 'عمليات',
            render: (e) => {
                return <EditModal id={e.id} os={e.os} name={e.name} mode={e.mode}
                          appDomain={e.appDomain} code={e.code} deprecate={e.deprecate}
                                  desc={e.desc} downloadsUrl={e.downloadsUrl}
                                  setVersionList={setVersionList} pageNumber={pageNumber}

                />
            }

        },
    ];


    switch (step) {
        case 0:
            return <Row style={{ width: '100', justifyContent: 'center' }}>
                <SpinnerDotted size={89} thickness={180} speed={92} color="rgba(0, 0, 0, 0.85)" style={{ marginTop: '100px' }} />
            </Row>

        case 1:
            return (
                versionList
                    ? <>
                        <Row style={{ background: 'white', marginBottom: '10px' }}>
                            <Col xxl={20} xl={20} lg={20} md={20} sm={20} xs={20} >
                                <Input
                                    onChange={(e) => { setSearch(e.target.value) }}
                                    id="userSerachInput"
                                    placeholder='برای جستجو نام ورژن را وارد نمایید...'
                                />
                            </Col>
                            <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4} >
                                <Button onClick={searching} id='userSearchButton'>جستجوی ورژن</Button>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                    <InsertVersion pageNumber={pageNumber} setVersionList={setVersionList} />
                            </Col>
                        </Row>

                        <Table id='userTableList' columns={columns} dataSource={versionList} pagination={false} tableLayout={{}}/>
                        <Row style={{width:'100%', justifyContent:'center'}}>
                            <Pagination
                                style={{direction:'ltr',marginTop:"20px"}}
                                current={pageNumber}
                                total={totalPage}
                                pageSize={10}
                                onChange={
                                    (e)=>{
                                        setPageNumber(e)
                                    }
                                } />
                        </Row>

                    </>
                    :
                    <>
                        <p className='orderColumeText' >ورژنی حاضر براي نمايش وجود ندارد</p>
                    </>
            )



    }
}
export default UserList;

